import { ComponentProps } from 'react'

import { Upload } from './upload'

const DEFAULT_MAX_SIZE = 50 * 1024 * 1024 // 50MB

type Props = ComponentProps<typeof Upload>

export const ImageUpload = ({ children, ...props }: Props) => {
  return (
    <Upload accept=".jpg,.jpeg,.png" maxSize={DEFAULT_MAX_SIZE} {...props}>
      {children}
    </Upload>
  )
}
